import { Icon } from './Icon'

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand">
      <span className="brand-mark">
        <Icon name="chat" size={23} />
      </span>
      {!compact && (
        <span>
          convo<span className="brand-dot">.</span>
        </span>
      )}
    </span>
  )
}
